"use client";

import { useState } from "react";

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@workspace/ui/components/accordion";
import { Button } from "@workspace/ui/components/button";
import { Icons } from "@workspace/ui/components/icons";

import { useAnalytics } from "~/lib/analytics";

import type { QuestionsProps } from ".";

export const QuestionsClient = ({ questions }: QuestionsProps) => {
  const { track } = useAnalytics();
  const [allShown, setAllShown] = useState(false);

  const questionsToDisplay = allShown ? questions : questions.slice(0, 7);

  return (
    <>
      <div className="flex w-full flex-col items-center justify-center gap-8">
        <Accordion className="flex w-full flex-col items-center justify-center gap-4">
          {questionsToDisplay.map((question) => (
            <AccordionItem
              key={question.id}
              value={question.id}
              className="bg-card text-card-foreground w-full max-w-4xl rounded-lg border px-5 py-4 shadow-xs"
            >
              <AccordionTrigger className="flex w-full items-center justify-between gap-3">
                <h3 className="text-left font-medium text-pretty">
                  {question.question}
                </h3>
                <Icons.ChevronDown className="size-5 shrink-0 transition-transform duration-200 group-data-[expanded]:-rotate-180 md:size-6" />
              </AccordionTrigger>
              <AccordionContent>
                <div className="max-w-3xl space-y-2 pt-2 text-pretty">
                  {question.answer}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {questions.length > 5 && (
          <Button
            variant="outline"
            className="bg-card dark:hover:bg-card/75 gap-2 rounded-xl px-4 shadow-xs"
            onClick={() => {
              setAllShown((a) => !a);
              track("show_more_click", { type: "faq" });
            }}
          >
            {allShown ? (
              <Icons.Minus className="text-primary w-3" />
            ) : (
              <Icons.Plus className="text-primary size-4" />
            )}
            Read {allShown ? "less" : "all"} FAQs
          </Button>
        )}
      </div>
    </>
  );
};
